import React, { useState, useEffect } from 'react';
import { useLocation, Navigate, Link, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import '../index.css';
import logo from '../assets/spinner.gif'
import { getCustomerTickets, performCustomerInput, UseLocalStorage, GetAttributesByAssignment } from "../functions";

function CustomerMaint() {
    const [localStorageAttributes, setLocalStorageAttributes] = UseLocalStorage('attributes', []);

    const navigate = useNavigate();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalText, setModalText] = React.useState("Error saving");
    const [modalType, setModalType] = React.useState("error"); // "success" or "error"
    const [loading, setLoading] = useState(false);

    function openModal(success) {
        setModalType(success ? "success" : "error");
        setIsOpen(true);

        setTimeout(() => {
            closeModal();
            if (success) {
                navigate('/Customers');
            }
        }, 2200);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const location = useLocation();

    const customer = location.state

    const [name, setName] = useState(customer ? customer.name : "");
    const [shippingaddress, setShippingAddress] = useState(customer ? customer.address : "");
    const [phone, setPhone] = useState(customer ? customer.phone : "");
    const [email, setEmail] = useState(customer ? customer.email : "");
    const [notes, setNotes] = useState(customer ? customer.notes : "");

    const [ticketList, setTicketList] = useState([]);

    const ticketAttributes = GetAttributesByAssignment('tickets', localStorageAttributes);
    const customerAttributes = GetAttributesByAssignment('customers', localStorageAttributes);
    const customerTags = customerAttributes.tags.sort((a, b) => a.displayorder.localeCompare(b.displayorder));

    let pageTitle = customer ? "Update " + customerAttributes.displayname : "Create " + customerAttributes.displayname;
    let submitText = customer ? "Update" : "Create";

    useEffect(() => {
        if (login) {
            const loadPost = async () => {
                setLoading(true);

                let tList = await getCustomerTickets(name);
                if (tList != null) {
                    setTicketList(tList);
                } else {
                    setTicketList([]);
                }
                setLoading(false);
            };
            loadPost();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const cookies = new Cookies();
    let login = cookies.get('login');
    if (!login) {
        return (<Navigate to={{ pathname: '../Login' }} />);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let data = {};
        data.name = name;
        data.address = shippingaddress;
        data.phone = phone;
        data.email = email;
        data.notes = notes;

        setLoading(true);

        try {
            const result = await performCustomerInput(data);
            if (result) {
                let localStorageCustomers = JSON.parse(localStorage.getItem('customers')) || [];

                if (customer) {
                    // Update existing customer
                    const customerIndex = localStorageCustomers.findIndex(c => c.name === customer.name);
                    if (customerIndex !== -1) {
                        localStorageCustomers[customerIndex] = data;
                    } else {
                        // If not found, add as new
                        localStorageCustomers.push(data);
                    }
                } else {
                    // Add new customer
                    localStorageCustomers.push(data);
                }

                localStorage.setItem('customers', JSON.stringify(localStorageCustomers));
                setModalText('Customer ' + data.name + ' saved successfully!');
                setLoading(false);
                openModal(true);
            } else {
                setModalText('Error saving customer. Please try again.');
                setLoading(false);
                openModal(false);
            }
        } catch (error) {
            console.error('Error saving customer:', error);
            setModalText('Error saving customer. Please try again.');
            setLoading(false);
            openModal(false);
        }
    };

    const tagName = customerTags.find(item => item.tag === 'cname');
    const tagAddress = customerTags.find(item => item.tag === 'address');
    const tagPhoneNumber = customerTags.find(item => item.tag === 'phonenumber');
    const tagEmail = customerTags.find(item => item.tag === 'email');
    const tagNotes = customerTags.find(item => item.tag === 'notes');

    return (
        <>
            <div className="CustomerMaint">
                <h1>{pageTitle}</h1>

                {/* Success/Error Modal */}
                {modalIsOpen && (
                    <div className="custom-modal-overlay" onClick={closeModal}>
                        <div
                            className={`custom-modal ${modalType === "success" ? "success" : "error"}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-icon">
                                {modalType === "success" ? (
                                    <div className="checkmark-circle">
                                        <div className="checkmark"></div>
                                    </div>
                                ) : (
                                    <div className="error-circle">
                                        <div className="error-x"></div>
                                    </div>
                                )}
                            </div>
                            <h2 className="modal-title">
                                {modalType === "success" ? "Success!" : "Error!"}
                            </h2>
                            <p className="modal-message">{modalText}</p>
                            <div className="modal-progress-bar">
                                <div className="modal-progress-fill"></div>
                            </div>
                            {modalType === "success" && (
                                <p className="modal-redirect-text">Redirecting to customers...</p>
                            )}
                        </div>
                    </div>
                )}

                <div className="customer-form-container">
                    {customer && (
                        <div className="form-actions">
                            <Link to="/TicketMaint" state={customer} className="new-ticket-btn">
                                <span className="btn-icon">+</span>
                                New {ticketAttributes.displayname}
                            </Link>
                        </div>
                    )}

                    <form className="customer-form" onSubmit={handleSubmit}>
                        <div className="form-section">
                            <h3>Customer Information</h3>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="name">{tagName.displayname}</label>
                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            {tagEmail.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="email">{tagEmail.displayname}</label>
                                        <input
                                            type="email"
                                            id="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}

                            {tagPhoneNumber.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="phone">{tagPhoneNumber.displayname}</label>
                                        <input
                                            type="text"
                                            id="phone"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}

                            {tagAddress.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <label htmlFor="shippingaddress">{tagAddress.displayname}</label>
                                        <textarea
                                            id="shippingaddress"
                                            value={shippingaddress}
                                            onChange={(e) => setShippingAddress(e.target.value)}
                                            rows={3}
                                        />
                                    </div>
                                </div>
                            )}

                            {tagNotes.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <label htmlFor="notes">{tagNotes.displayname}</label>
                                        <textarea
                                            id="notes"
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                            rows={4}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="form-submit">
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Saving...' : submitText}
                                </button>
                            </div>
                        </div>
                    </form>

                    {/* Recent Tickets Section */}
                    {customer && (
                        <div className="recent-tickets-section">
                            <h3>Recent {ticketAttributes.displayplural}</h3>
                            {loading ? (
                                <div className="loading-container">
                                    <img src={logo} style={{ width: '30px' }} alt="loading..." />
                                </div>
                            ) : ticketList.length > 0 ? (
                                <div className="ticket-list">
                                    {ticketList.map((t, index) => (
                                        <div key={index} className="ticket-item">
                                            <Link to="/TicketMaint" state={t} className="ticket-link">
                                                <span className="ticket-date">{t.orderdate}</span>
                                                <span className="ticket-id">#{t.id}</span>
                                                <span className="ticket-product">{t.product}</span>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p className="no-tickets">No recent tickets found.</p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );

}

export default CustomerMaint;
